import { render, staticRenderFns } from "./AmountOrders.vue?vue&type=template&id=6822dfe2&scoped=true&"
import script from "./AmountOrders.vue?vue&type=script&lang=js&"
export * from "./AmountOrders.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/widgets.css?vue&type=style&index=0&id=6822dfe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6822dfe2",
  null
  
)

export default component.exports